<script lang="ts">
import useText from "@/composable/components/text";
import useBoolean from "@/composable/components/boolean";
import { FileUrl, useRedirections } from "@/composable/applications/useFunction";
import { formatedDateArray } from "@/composable/application/datePattern";
import { PropType, ref } from "vue";
import { useRouter } from "vue-router";
import DetailApplicationModalCard from "@/components/application/DetailApplicationModalCard.vue";
import "@/style/components/ApplicationCard.scss";
import truncate from "@/composable/components/title";
import TitleCardWithLimitLength from "@/components/common/TitleCardWithLimitLength.vue";
import { LocalApplicationLightResult } from "@/types/front/LocalApplicationLightResult";

export default {
  name: "ApplicationCard",
  components: { TitleCardWithLimitLength, DetailApplicationModalCard },
  props: {
    applicationLightResult: {
      type: Object as PropType<LocalApplicationLightResult>,
      required: true,
    },
    applicationRoles: {
      type: Array,
      default: () => [],
    },
    index: {
      required: true,
      type: Number,
    },
    current: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const selectedName = useText().refText;
    const isCardModalActive = useBoolean().refBoolean;
    const { landingPageApplication } = useRedirections(props.applicationLightResult);

    const localLang = localStorage.getItem("lang");
    const url = useText().refText;
    const redirection = ref(() => {
      router.push(`/applications/${props.applicationLightResult.application.name}`);
    });
    const showCharte = async function (objectShowChartePromise: Promise<void | FileUrl>) {
      if (!objectShowChartePromise) {
        return;
      }

      const objectShowCharte = await objectShowChartePromise;
      if (!objectShowCharte) {
        return;
      }
      isCardModalActive.value = true;
      url.value = objectShowCharte.url;
      if (objectShowCharte.redirection) {
        redirection.value = objectShowCharte.redirection;
      }
    };
    return {
      selectedName,
      isCardModalActive,
      localLang,
      showCharte,
      url,
      redirection,
      landingPageApplication,
    };
  },
  methods: { formatedDateArray, truncate },
};
</script>
<template>
  <div
    v-if="index >= (current - 1) * perPage && index < current * perPage"
  >
    <b-modal
      v-if="isCardModalActive"
      v-model="isCardModalActive"
      class="modalByAgrégation"
      full-screen
    >
      <DetailApplicationModalCard
        :id="applicationLightResult.application.name"
        v-model="isCardModalActive"
        :application="applicationLightResult"
        :application-roles="applicationRoles"
        :close-cb="redirection"
        :open="isCardModalActive"
        :redirection="redirection"
        :url="url"
      />
    </b-modal>
    <div>
      <div class="applicationCard">
        <div class="card-header">
          <div class="title card-header-title">
            <TitleCardWithLimitLength
              :local-name="applicationLightResult.application.localName"
              :limit="20"
            />
          </div>
        </div>
        <hr>
        <div class="card-content">
          <div class="content">
            <p
              v-if="applicationLightResult.application.updateDate || applicationLightResult.application.creationDate"
              :aria-label="applicationLightResult.application.updateDate
                ? formatedDateArray(applicationLightResult.application.updateDate)
                : formatedDateArray(applicationLightResult.application.creationDate)"
              field="creationDate"
            >
              {{
                applicationLightResult.application.updateDate
                  ? formatedDateArray(applicationLightResult.application.updateDate)
                  : formatedDateArray(applicationLightResult.application.creationDate)
              }}
            </p>
            <p
              v-if="applicationLightResult.application.version"
              :aria-label="applicationLightResult.application.version"
              field="creationDate"
            >
              {{ "version :" + applicationLightResult.application.version }}
            </p>
          </div>
        </div>
        <div class="card-footer">
          <div class="card-footer-item">
            <b-button
              :aria-label="applicationLightResult.application.name"
              expanded
              icon-left="eye"
              type="is-primary"
              @click="showCharte(landingPageApplication(applicationLightResult))"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
